/*
 * ShiftApplicationEvent Messages
 *
 * This contains all the text for the ShiftApplicationEvent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  planningInProgress: {
    id: 'app.components.ShiftApplicationEvent.planningInProgress',
    defaultMessage: 'Planning in progress',
  },
});
